export enum FindingTypesSchema {
  radiographic_boneloss = 'RADIOGRAPHIC_BONE_LOSS',
  caries = 'CARIES',
  periapical_radiolucency = 'PERIAPICAL_RADIOLUCENCY',
  area_of_concern = 'CARIES',
  restorative_adjacent_lucency = 'RESTORATIVE_ADJACENT_LUCENCY',
}
export enum FindingValidations {
  Agree = 'Agree',
  Monitor = 'Monitor',
  Disagree = 'Disagree',
}

export enum RblToothSides {
  mesial = 'mesial',
  distal = 'distal',
  center = 'center',
}

export type PersistUserValidationsRequest = {
  findingType: FindingTypesSchema;
  validationStatus: FindingValidations;
  toothNumber?: number | string;
  rblToothSurface?: RblToothSides;
};
